var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconLeave = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M21.424 12.227a.6.6 0 0 0 0-.849l-3-3a.6.6 0 0 0-.848.849l1.975 1.976H9a.6.6 0 1 0 0 1.2H19.55l-1.975 1.975a.6.6 0 1 0 .848.849z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12 4.903a2.4 2.4 0 0 1 2.4 2.4v.75a.6.6 0 1 0 1.2 0v-.75a3.6 3.6 0 0 0-3.6-3.6H6a3.6 3.6 0 0 0-3.6 3.6v9a3.6 3.6 0 0 0 3.6 3.6h6a3.6 3.6 0 0 0 3.6-3.6v-.75a.6.6 0 0 0-1.2 0v.75a2.4 2.4 0 0 1-2.4 2.4H6a2.4 2.4 0 0 1-2.4-2.4v-9a2.4 2.4 0 0 1 2.4-2.4z"
})));
export { SvgIconLeave as ReactComponent };